import React from "react"
import clsx from "clsx"
import numeral from "numeral"

class CashDrawerPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-7">
            {this.renderGeneralForm()}
          </div>
        </div>
      </div>
    )
  }

  renderGeneralForm() {
    return (
      <div className="row">
        <div className="col-sm-3">
          <div className="form-group" style={{marginBottom: 0}}>
            <label>{`${I18n.t('code')}*`}</label>
            <div>{this.props.cash_drawer.code}</div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group" style={{marginBottom: 0}}>
            <label>{`${I18n.t('name')}*`}</label>
            <div>{this.props.cash_drawer.name}</div>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="form-group" style={{marginBottom: 0}}>
            <label>{I18n.t('current_balance')}</label>
            <div>${numeral(this.props.cash_drawer.current_balance / 100).format(this.state.numberFormat)}</div>
          </div>
        </div>
      </div>
    )
  }

}

export default CashDrawerPresenterGeneral